import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LocationService {
  get href(): string {
    return window.location.href;
  }

  set href(value: string) {
    window.location.href = value;
  }
}
